import styled, { css } from 'styled-components';

import { ActionButton } from 'components/ui/Button';

import { colours } from 'themes/default';

const sharedButtonStyling = css`
  width: 100%;
  margin: 4px 0;
  background: ${colours.Core.CoreNavy};
  border: none;
  border-radius: 2px;

  > div {
    color: white;
  }

  &:hover {
    background: ${colours.Core.CoreNavy};
    opacity: 0.5;
    > div {
      color: white;
    }
  }

  &:disabled,
  &[disabled] {
    background: ${colours.Greyscale.MistGrey};
    > div {
      color: ${colours.Greyscale.CharcoalGrey};
    }
  }
`;

export const StyledActionButton = styled(ActionButton)`
  ${sharedButtonStyling}
`;

export const ButtonWrapper = styled.div`
  display: flex;
  width: 100%;

  justify-content: flex-end;

  button {
    width: 250px;
    margin-left: 20px;
  }
`;

export const StyledTextarea = styled.textarea`
  width: 100%;
`;
